import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
// import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

// init Swiper:
const swiper = new Swiper('.media-hero-carousel', {
    // configure Swiper to use modules
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    // fade
    effect: "fade",
    autoplay: {
        delay: 4000,
    },
    loop: true,
    fadeEffect: { crossFade: true },
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev'
    // }
});

if($('.media-hero-video').length) {
    $('.media-hero-video').each(function() {
        let filePath = $(this).find('.video-file-path').val(),
            container = $(this);

        console.log('Media Hero Video File Path:', filePath);

        if(filePath) {
            let videoObject = document.createElement("video"),
                sourceMP4 = document.createElement("source");

            sourceMP4.type = "video/mp4";
            sourceMP4.src = filePath;
            videoObject.appendChild(sourceMP4);

            videoObject.autoplay = true;
            videoObject.muted = true;
            videoObject.loop = true;
            videoObject.load();

            let playPromise = videoObject.play();

            if (playPromise !== undefined) {
                playPromise.then(function () {
                    // Automatic playback started!
                }).catch(function (error) {
                    // Automatic playback failed.
                    // Show a UI element to let the user manually start playback.
                });
            }

            container.append(videoObject);
        }
    });
}
